/*
 * Copyright (C) 2026 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { ContentHelper } from '@app/app/shared/helpers/content-helper';
import { VersionHelper } from '@app/app/shared/helpers/version.helper';

/**
 * Shared assignment work lives on frameless top-level routes, outside the app frame, so a public link opens without
 * a session. The backend builds `ShareDetails.path` from the same two routes.
 */
export const SHARED_WORK_ROOT = 'shared';
export const PUBLIC_SHARED_WORK_PREFIX = `/${SHARED_WORK_ROOT}/assignments/p/`;
export const MY_SHARED_WORK_PATH = `/${SHARED_WORK_ROOT}/mine`;

/** The signed-in page of a share, which course members, its owner and course staff open by id. */
export function sharedWorkPath(shareId: string): string {
  return `/${SHARED_WORK_ROOT}/assignments/${shareId}`;
}

/** A public link's page, which must work signed out: the auth checks leave it alone. */
export function isPublicSharedWorkUrl(pathname: string): boolean {
  return pathname.startsWith(PUBLIC_SHARED_WORK_PREFIX);
}

/**
 * Where a learner sees everything they have shared. The Evidence page has a tab for it, but an LMS launch has no
 * sidebar to reach Evidence and a V2 org has no Evidence page, so both get the frameless page.
 */
export function mySharedWorkUrl(): string {
  return ContentHelper.isFrameMode() || !VersionHelper.isV3Enabled() ? MY_SHARED_WORK_PATH : '/evidence?tab=shared';
}
